<div
  class="tw-mx-auto tw-flex tw-flex-col tw-items-center tw-justify-center tw-px-4 tw-pt-7 tw-pb-8 xs:tw-px-4 tw-max-w-lg"
>
  <div>
    <img class="logo tw-w-72 tw-h-auto" alt="Gloss" />
    <p *ngIf="text" class="tw-mx-4 tw-mb-4 tw-mt-3 tw-text-center tw-text-xl">
      {{ text | i18n }}
    </p>
  </div>
  <div class="tw-w-full">
    <router-outlet (activate)="onActivate()"></router-outlet>
  </div>
  <div class="tw-my-1 tw-text-center tw-uppercase tw-pt-4">
    <span class="tw-text-dt-text-disabled tw-font-normal tw-text-[10px]"
      >&copy; {{ year }} {{ IRONFLY_TECHNOLOGIES }} <br
    /></span>
    <span class="tw-text-dt-text-disabled tw-font-normal tw-text-[10px] tw-pt-3">{{
      "versionNumber" | i18n: version
    }}</span>
  </div>
</div>
